// Copyright (c) 2016 Deere & Company

import './checkbox-filter.scss';
import React, {PropTypes} from 'react';
import Accordion from '../../../../shared/components/accordion';
import CheckboxFilterBody from './checkbox-filter-body';
import {translate} from '../../../services/translation-service';

const CheckboxFilterControlled = props => {

    const checkboxFilterBody = (
        <CheckboxFilterBody
            canUseDefaultFormat={props.canUseDefaultFormat}
            initialState={props.initialState}
            list={props.list}
            minNumberOfItems={props.minNumberOfItems}
            onChange={props.onChange}
            onToggleAll={props.onToggleAll}
            valueKey={props.valueKey}
        />
    );

    return (
        <section className='checkbox-filter'>
            <Accordion
                accordionId='checkbox-filter-accordion'
                body={checkboxFilterBody}
                isExpanded={props.isExpanded}
                onClick={props.onClick}
                title={translate(props.title)}
            />
        </section>
    );

};

CheckboxFilterControlled.displayName = 'CheckboxFilterControlled';
CheckboxFilterControlled.propTypes = {
    canUseDefaultFormat: PropTypes.bool,
    displayKey: PropTypes.string,
    initialState: PropTypes.object.isRequired,
    isExpanded: PropTypes.bool.isRequired,
    list: PropTypes.array.isRequired,
    minNumberOfItems: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    onToggleAll: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    valueKey: PropTypes.string.isRequired
};

export default CheckboxFilterControlled;



// WEBPACK FOOTER //
// ./src/shared/components/facets/checkbox-filter/controlled.js